import { formatLastSaved } from "../hooks/useAutoSave.js";

function RestorePrompt({ lastSaved, onResume, onStartFresh }) {
  return (
    <div className="restore-prompt">
      <div className="restore-prompt-icon">
        <i className="fas fa-history"></i>
      </div>
      <div className="restore-prompt-text">
        <strong>Resume your work?</strong>
        <span>
          You have a saved draft from {formatLastSaved(lastSaved)}. Would you
          like to resume where you left off?
        </span>
      </div>
      <div className="restore-prompt-actions">
        <button type="button" className="restore-resume-btn" onClick={onResume}>
          <i className="fas fa-play"></i> Resume
        </button>
        <button
          type="button"
          className="restore-start-fresh-btn"
          onClick={onStartFresh}
        >
          <i className="fas fa-trash"></i> Start Fresh
        </button>
      </div>
    </div>
  );
}

export default RestorePrompt;
